import * as marietta from '../..';
import { CONTROL_ACTIONMODE, WALLPINTEXT_Z } from '../Constants';
import { ItemControllerFreeCharacterInput } from './';

interface attributeType {
  category?: number,
  file_name?: string,
  file_id: string,
  file_path: string
}

export class ItemControllerPanoramaPinInput extends ItemControllerFreeCharacterInput {

  constructor() {
    super(false);

    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    // 作成する階
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor) as marietta.webcad.layer.FloorLayer;

    marietta.webcad.WebCADGlobal.removeDialog();
    this.tarDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PinPanoramaInputDialog, false, false, false, false);
    // 入力ダイアログからのコールバック関数
    this.tarDialog.callBack = this.createText;
  }

  /**
   * 入力ダイアログからのコールバック関数
   * @param text
   */
  createText = (textAttribute: attributeType) => {
    this.textAttribute = textAttribute;
    const stage = document.querySelector('#layerGroup');
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.addEventListener('touchstart', this.getClickPoint, { passive: false });
      stage.addEventListener('touchmove', this.getClickPoint, { passive: false });
      stage.addEventListener('touchend', this.onMouseUp, { passive: false });
    } else {
      stage.addEventListener('mouseup', this.onMouseUp);
    }
  }

  /**
   * テキストアイテムの作成
   */
  createItem = () => {
    const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
    // info.id = `${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${PINPANORAMA_ITEMCODE}`;
    info.id = marietta.webcad.WebCADGlobal.getPinPanoramaId(this.textAttribute[0].text_category);

    info.guid = marietta.webcad.WebCADGlobal.getGuid();
    info.x = this.mousePlace.x;
    info.y = this.mousePlace.y;
    info.text_color = this.textAttribute[0].text_color;
    info.font_size = this.textAttribute[0].font_size;
    info.is_bold = this.textAttribute[0].is_bold;
    info.is_italic = this.textAttribute[0].is_italic;
    info.is_underline = this.textAttribute[0].is_underline;
    info.is_strike_through = this.textAttribute[0].is_strike_through;
    info.text_alignment = this.textAttribute[0].text_alignment;
    info.text = this.textAttribute[0].text;
    if (this.textAttribute[0]?.file_path) {
      info.link = [
        {
          name: this.textAttribute[0]?.file_name ?? '',
          url: this.textAttribute[0].file_path
        }
      ];
    }
    /** ローカル画像をアップロードした際のAPI返り値 */
    if (this.textAttribute[0]?.file_id) {
      info.file_id = this.textAttribute[0]?.file_id;
    }
    const textSize = marietta.webcad.util.TextUtil.getTextSizeWh(this.textAttribute[0].text, marietta.webcad.WebCADGlobal.freeTextFontFamily, marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size);
    info.width = textSize.width;
    info.height = textSize.height;
    if (info.id != 'txt04_02') {
      info.z = 0;
    } else {
      const heightData = marietta.webcad.WebCADGlobal.itemManager.getFloorAndCeilingHeight();
      const fl = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor === 1 ? heightData.fl1 : marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor === 2 ? heightData.fl2 : heightData.fl3;
      info.z = fl + WALLPINTEXT_Z;
    }
    marietta.webcad.WebCADGlobal.itemManager.createItem(info);
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    this.clean();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    (<HTMLInputElement>document.getElementById('btnPinTextInput360')).checked = false;
  }
}
